import React, { Component } from 'react'
import { Provider } from 'react-redux'
import Modal from 'react-modal'
import configureStore, { history } from './store'
import Template from './components/Template'
import ErrorBoundary from './containers/ErrorBoundary'

Modal.setAppElement('.container');

class App extends React.Component {
  render() {
    const store = configureStore({
      global: this.props
    });

    return (
      <Provider store={store}>
        <ErrorBoundary>
          <Template history={history} />
        </ErrorBoundary>
      </Provider>
    )
  }
}

export default App
